import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-148" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-6xl" data-id="element-149" data-mp="2worlhz9449gj">
        <div className="mx-auto max-w-2xl text-center" data-id="element-150" data-mp="2wqm9xnjlejpd">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-151" data-mp="2rpf0zl5preh4">
            TI RICONOSCI?
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-152" data-mp="35nwmdc85cevv">
            Le sei frasi che sentiamo più spesso
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-muted md:text-base" data-id="element-153" data-mp="3fg2c0faxek7w">
            Se anche solo una di queste ti suona familiare, questo pacchetto è stato pensato per te.
          </p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-154" data-mp="3ofpbuwo0bhyu">
          {painPoints.map(({
          icon: PointIcon,
          quote,
          detail
        }) => <article key={quote} className="flex flex-col rounded-xl border border-line bg-sand p-6 text-left shadow-soft" data-id="element-155" data-mp="3kggktzkcpy6z">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-sage" data-id="element-156" data-mp="wxejas5nzmyk">
                <PointIcon className="h-5 w-5" strokeWidth={1.8} aria-hidden="true" data-id="element-157" data-mp="11uohaw74d6y0" />
              </span>
              <p className="mt-5 font-heading text-base font-semibold leading-snug text-petrol" data-id="element-158" data-mp="16vc9vmazxvuc">{quote}</p>
              <p className="mt-auto pt-3 font-note text-xs leading-relaxed text-muted" data-id="element-159" data-mp="1bt47mwyboc6g">{detail}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}